'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var testimonialsData = exports.testimonialsData = [{
  quote: 'Now that I’m on ClassPass, I exercise about 75% more than I did, and I’m feeling happier and healthier than ever before.',
  source: 'Ellen',
  location: 'London'
}, {
  quote: 'After paying gym fees for years and never getting my moneyʼs worth, I am so happy I can fit in the workouts I want.',
  source: 'Emily',
  location: 'San Diego'
}, {
  quote: 'Without ClassPass, I’d never be able to afford Pilates reformer classes and yoga studios. ClassPass makes it all possible.',
  source: 'Carolyn',
  location: 'Toronto'
}];